import React from 'react';
import ReactDOM from 'react-dom/client';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/it';
import { BrowserRouter, Routes ,Route } from 'react-router-dom';

import './global.css';

import { ProvideAuth } from './Auth/ProvideAuth'
import App from './App';
import CmsLayout from './Layout/CmsLayout';
import Dashboard from './Pages/Dashboard';
import Account from './Pages/Account';
import RouteManager from './RouteManager';
import NotFound from './Pages/NotFound';
import Login from './Pages/Login';

import Customer from './Pages/Customer';
import Annotation from './Pages/Annotation';
import Installation from './Pages/Installation';
import Deadline from './Pages/Deadline';
import Appointment from './Pages/Appointment';
import AppointmentWork from './Pages/AppointmentWork';
import Stamp from './Pages/Stamp';
import Supplier from './Pages/Supplier';
import Category from './Pages/Category';
import Spare from './Pages/Spare';
import Report from './Pages/Report';
import Timetable from './Pages/Timetable';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'font-awesome/css/font-awesome.min.css';
import Producer from './Pages/Producer';
import Message from './Pages/Message';
import TemplateDoc from './Pages/TemplateDoc';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
		<ProvideAuth>
			<BrowserRouter >
				<Routes>
					<Route exact path='/login' element={<Login />} />
					<Route exact path='/' element={<App />} />
					<Route exact path='/cms' element={<RouteManager component={CmsLayout} />}>
						<Route exact path="/cms" element={<RouteManager component={Dashboard} />} />	{/* Main content */}								{/* https://localhost:3000/cms */}
						<Route exact path="account" element={<RouteManager component={Account} />} />

						<Route exact path="customers" element={<RouteManager component={Customer} role="backoffice" />} />
						<Route exact path="customers/edit/:customer" element={<RouteManager component={Customer} role="backoffice" />} />
						<Route exact path="customers/create" element={<RouteManager component={Customer} role="backoffice" />} />

						<Route exact path="annotations" element={<RouteManager component={Annotation} role="backoffice" />} />
						<Route exact path="annotations/edit/:annotation/:customer" element={<RouteManager component={Annotation} role="backoffice" />} />
						<Route exact path="annotations/create/:customer" element={<RouteManager component={Annotation} role="backoffice" />} />

						<Route exact path="installations" element={<RouteManager component={Installation} role="backoffice" />} />
						<Route exact path="installations/edit/:installation/:customer" element={<RouteManager component={Installation} role="backoffice" />} />
						<Route exact path="installations/move/:installation/:customer" element={<RouteManager component={Installation} role="backoffice" />} />
						<Route exact path="installations/create/:customer" element={<RouteManager component={Installation} role="backoffice" />} />

						{/*<Route exact path="deadlines" element={<RouteManager component={Deadline} role="backoffice" />} />*/}
						<Route exact path="deadlines/edit/:deadline/:installation/:customer" element={<RouteManager component={Deadline} role="backoffice" />} />
						<Route exact path="deadlines/create/:installation/:customer" element={<RouteManager component={Deadline} role="backoffice" />} />

						<Route exact path="appointments" element={<RouteManager component={Appointment} role="backoffice" />} />
						<Route exact path="appointments/edit/:appointment" element={<RouteManager component={Appointment} role="backoffice" />} />
						<Route exact path="appointments/create" element={<RouteManager component={Appointment} role="backoffice" />} />
						<Route exact path="appointments/work/:appointment" element={<RouteManager component={AppointmentWork} />} />
						<Route exact path="appointments/createFromExpire/:expiration" element={<RouteManager component={Appointment} role="backoffice" />} />

						<Route exact path="stamps" element={<RouteManager component={Stamp} role="backoffice" />} />

						<Route exact path="suppliers" element={<RouteManager component={Supplier} role="backoffice" />} />
						<Route exact path="suppliers/edit/:supplier" element={<RouteManager component={Supplier} role="backoffice" />} />
						<Route exact path="suppliers/create" element={<RouteManager component={Supplier} role="backoffice" />} />

						<Route exact path="producers" element={<RouteManager component={Producer} role="backoffice" />} />
						<Route exact path="producers/edit/:producer" element={<RouteManager component={Producer} role="backoffice" />} />
						<Route exact path="producers/create" element={<RouteManager component={Producer} role="backoffice" />} />

						<Route exact path="categories" element={<RouteManager component={Category} role="backoffice" />} />
						<Route exact path="categories/edit/:category" element={<RouteManager component={Category} role="backoffice" />} />
						<Route exact path="categories/create" element={<RouteManager component={Category} role="backoffice" />} />

						<Route exact path="messages" element={<RouteManager component={Message} role="backoffice" />} />
						<Route exact path="messages/edit/:message" element={<RouteManager component={Message} role="backoffice" />} />
						<Route exact path="messages/create" element={<RouteManager component={Message} role="backoffice" />} />

						<Route exact path="spares" element={<RouteManager component={Spare} />} />
						<Route exact path="spares/edit/:spare" element={<RouteManager component={Spare} />} />
						<Route exact path="spares/create" element={<RouteManager component={Spare} />} />

						<Route exact path="reports" element={<RouteManager component={Report} role="backoffice" />} />
						<Route exact path="reports/received-payments" element={<RouteManager component={Report} role="backoffice" />} />
						<Route exact path="reports/customers-to-invoice" element={<RouteManager component={Report} role="backoffice" />} />
						<Route exact path="reports/customers-without-payment" element={<RouteManager component={Report} role="backoffice" />} />
						<Route exact path="reports/return-notes" element={<RouteManager component={Report} role="backoffice" />} />
						<Route exact path="reports/appointments-overview" element={<RouteManager component={Report} role="backoffice" />} />

						<Route exact path="timetable" element={<RouteManager component={Timetable} role="backoffice" />} />

						<Route exact path="template-doc" element={<RouteManager component={TemplateDoc} role="administrator" />} />
					</Route>
					<Route path='*' element={<NotFound />} />
				</Routes>
			</BrowserRouter >
		</ProvideAuth>
		</LocalizationProvider>
	</React.StrictMode>
);
